import { render, staticRenderFns } from "./AddEquipment.vue?vue&type=template&id=3397ef14&scoped=true&"
import script from "./AddEquipment.vue?vue&type=script&lang=js&"
export * from "./AddEquipment.vue?vue&type=script&lang=js&"
import style0 from "./AddEquipment.vue?vue&type=style&index=0&id=3397ef14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3397ef14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
